import { Component } from '@angular/core';

@Component({
  template: require('./materiais.component.html')
})
export class MateriaisComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/materiais.component.ts
 **/